import React from 'react';
import Position from './Position';
/** @type {any} */
const PinTR = React.forwardRef(({ children, ...props }, ref) => (React.createElement(Position, Object.assign({ position: "absolute", ref: ref, right: 0, top: 0 }, props), children)));
export default PinTR;
